import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { dashboardActions } from "../slices/dashboard";
import { getErrorMessage } from "../../utils/errorUtils";
import { DashboardResponseDto } from "../../shared/dtos/dashboard/DashboardResponseDto";
import { ActivityLogRequestDto } from "../../shared/dtos/dashboard/ActivityLogRequestDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getDashboardStats =
  (limit?: number) => async (dispatch: AppDispatch) => {
    dispatch(dashboardActions.setLoadingStats());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<DashboardResponseDto>
      >("/dashboard/stats", {
        headers: { requiresAuth: true },
        params: { limit },
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(dashboardActions.setStats(data.data));
      }
    } catch (error) {
      dispatch(dashboardActions.setErrorLoadingStats(getErrorMessage(error)));
    }
  };

export const trackUserActivity =
  (payload: ActivityLogRequestDto) => async (dispatch: AppDispatch) => {
    dispatch(dashboardActions.setTrackingActivity());
    try {
      await axiosInstance.post<ApiResponseDto<void>>(
        "/dashboard/track",
        payload,
        {
          headers: { requiresAuth: true },
        },
      );
      dispatch(dashboardActions.setTrackingSuccess());
    } catch (error) {
      console.warn("Tracking failed:", getErrorMessage(error));
      dispatch(
        dashboardActions.setErrorTrackingActivity(getErrorMessage(error)),
      );
    }
  };
